import 'css-chunksrc/client/pages/costProfilesPage/toolbar/sortDropdown/styles.scss';export default {
  "sortDropdown": "_sortDropdown_lpeji_1",
  "title": "_title_lpeji_10",
  "root": "_root_lpeji_16",
  "input": "_input_lpeji_20",
  "opened": "_opened_lpeji_38",
  "icon": "_icon_lpeji_43",
  "listRoot": "_listRoot_lpeji_55",
  "list": "_list_lpeji_55",
  "option": "_option_lpeji_71",
  "selected": "_selected_lpeji_79"
};